import React from 'react';
import { Row, Col, FormGroup, Button, ButtonToolbar, Radio } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Api from '../../../api/api';
import SubscriptionMethod from './SubscriptionMethod';

class Schedule extends React.Component {
  state = {
    schedule: this.props.schedule,
    subscription_method: this.props.subscription_method,
    btnDisabled: true,
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ schedule: nextProps.schedule, subscription_method: nextProps.subscription_method });
  }

  setMessage = message => this.setState({ message });

  selectFrequency = frequency =>
    this.setState({ schedule: { ...this.state.schedule, number_per_week: frequency }, btnDisabled: false });

  selectDeliveryDay = value => {
    const day_of_week_to_review = value - 1 >= 0 ? value - 1 : 6;

    this.setState({
      schedule: { ...this.state.schedule, day_of_week: value, day_of_week_to_review },
      btnDisabled: false,
    });
  };

  handleSubscriptionMethodChange = e => {
    const subscription_method = e.target.name;

    this.setState({ subscription_method, btnDisabled: false });
  };

  handleSubmit = () => {
    const scheduleWasChanged = JSON.stringify(this.props.schedule) !== JSON.stringify(this.state.schedule);

    scheduleWasChanged && this.updateSchedule();

    this.props.subscription_method !== this.state.subscription_method && this.updateSubscriptionMethod();
  };

  updateSchedule = () =>
    Api.users
      .updateSchedule(this.state.schedule)
      .then(() => {
        this.props.fetchSchedule();
        this.props.setMessage('Scheduling Section successfully updated.');
        this.setState({ btnDisabled: true });
      })
      .catch(() => this.props.setMessage("Couldn't update schedule info", 'danger'));

  updateSubscriptionMethod = () =>
    Api.users.updateUserData({ user: { subscription_method: this.state.subscription_method } }).then(() => {
      this.props.fetchUserData();
      this.props.setMessage('Scheduling Section successfully updated.');
      this.setState({ btnDisabled: true });
    });

  render() {
    const days = [
      { key: 0, name: 'Sunday' },
      { key: 1, name: 'Monday' },
      { key: 2, name: 'Tuesday' },
      { key: 3, name: 'Wednesday' },
      { key: 4, name: 'Thursday' },
      { key: 5, name: 'Friday' },
      { key: 6, name: 'Saturday' },
    ];

    const dayOfReview = days[this.state.schedule.day_of_week_to_review];

    return (
      <Row className="display-flex flex-direction-profile">
        <Col md={3} className="subscr-md">
          <SubscriptionMethod
            subscription_method={this.state.subscription_method}
            handleSubscriptionMethodChange={this.handleSubscriptionMethodChange}
            fetchUserData={this.props.fetchUserData}
            setMessage={this.props.setMessage}
          />
        </Col>

        <Col md={3} className="subscr-md-exercise">
          <div className="ex-frequency">
            <span className="exercise-frequency-main">Exercise Delivery</span>
            <FormGroup className="exercise-frequency">
              <Radio
                className="radio"
                checked={this.state.schedule.number_per_week === 1}
                onClick={() => this.selectFrequency(1)}
                name="radioGroup"
              >
                <span className="radio-text" />
                One exercise each week
              </Radio>
              <Radio
                className="radio"
                checked={this.state.schedule.number_per_week === 2}
                onClick={() => this.selectFrequency(2)}
                name="radioGroup"
              >
                <span className="radio-text" />
                Two exercises each week
              </Radio>
            </FormGroup>
          </div>
        </Col>
        <Col md={6}>
          <div className="ex-delivery">
            <span className="exercise-frequency-main">Exercise Delivery Day</span>
            <ButtonToolbar>
              {days.map(day => (
                <Button
                  onClick={() => this.selectDeliveryDay(day.key)}
                  key={day.key}
                  bsStyle={day.key === this.state.schedule.day_of_week ? 'primary' : null}
                  className={day.key !== this.state.schedule.day_of_week && 'schedule-button'}
                >
                  {day.name.substring(0, 2)}
                </Button>
              ))}
            </ButtonToolbar>
            {dayOfReview && (
              <span className="will-arrive">Exercise review emails will arrive on {dayOfReview.name}s</span>
            )}
          </div>
        {/*</Col>*/}
        {/*<Col md={2}>*/}
          <div className="profile-info-buttons ch-pass flex-end">
            <Button onClick={this.handleSubmit} disabled={this.state.btnDisabled} bsStyle="success">
              Save changes
            </Button>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({ schedule: state.schedule, subscription_method: state.user.subscription_method });

export default withRouter(connect(mapStateToProps)(Schedule));



// WEBPACK FOOTER //
// ./src/components/Dashboard/Schedule/Schedule.js